import { ICON_NAMES } from '../../constants';
export const articleConfig = {
    name: 'Article',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/1a634bb631bc562d9e341eb75fa9ee5e.svg',
    inputs: [
        {
            name: 'layout',
            type: 'string',
            enum: ['card', 'row'],
            required: true,
            defaultValue: 'card',
        },
        {
            name: 'url',
            type: 'string',
            required: true,
        },
        {
            name: 'imageUrl',
            type: 'cloudinaryMediaLibrary',
        },
        {
            name: 'title',
            type: 'string',
            required: true,
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'authorName',
            type: 'string',
            required: true,
        },
        {
            name: 'authorImageUrl',
            type: 'cloudinaryMediaLibrary',
        },
        {
            name: 'authorEmail',
            type: 'string',
            helperText: "Used for Gravatar if author image URL isn't provided",
        },
        {
            name: 'category',
            type: 'string',
        },
        {
            name: 'categoryUrl',
            type: 'string',
        },
        {
            name: 'label',
            type: 'string',
        },
        {
            name: 'labelIcon',
            type: 'string',
            enum: Object.values(ICON_NAMES),
        },
        {
            name: 'labelVariant',
            type: 'string',
            enum: ['primary', 'secondary', 'neutral'],
        },
        {
            name: 'metaDate',
            type: 'date',
        },
        {
            name: 'metaReadTime',
            type: 'number',
        },
    ],
};
//# sourceMappingURL=config.js.map